"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[243],{

/***/ 42969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QX": function() { return /* binding */ useHelpArticles; },
/* harmony export */   "Rj": function() { return /* binding */ useHelpArticleFeedback; },
/* harmony export */   "SG": function() { return /* binding */ useHelpArticle; }
/* harmony export */ });
/* unused harmony exports KEYS, getHelpArticlesKey, prefetchHelpArticles, getHelpArticleKey, prefetchHelpArticle */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67848);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48228);
/* harmony import */ var _httpClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16799);


const KEYS = {
    HELP_ARTICLES: "help-articles"
};
const getHelpArticles = async function() {
    let { category =null , locale ="en" , q ="" , page =1  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* .httpClient.get */ .M.get("/help-center/articles", {
        params: {
            language: locale,
            q,
            category_id: category,
            page
        }
    });
    return response.data;
};
const getHelpArticlesKey = function() {
    let { category =null , locale ="en" , q ="" , page =1  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return [
        KEYS.HELP_ARTICLES,
        "locale=".concat(locale),
        "category_id=".concat(category),
        "q=".concat(q),
        "page=".concat(page)
    ];
};
const useHelpArticles = (params)=>(0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(getHelpArticlesKey(params), async ()=>getHelpArticles(params), {
        keepPreviousData: true
    });
const prefetchHelpArticles = (queryClient, params)=>queryClient.prefetchQuery(getHelpArticlesKey(params), async ()=>getHelpArticles(params));
const getHelpArticle = async (slug)=>{
    const response = await _httpClient__WEBPACK_IMPORTED_MODULE_0__/* .httpClient.get */ .M.get("/help-center/articles/".concat(slug));
    return response.data;
};
const getHelpArticleKey = function(slug) {
    let { locale ="en"  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return [
        KEYS.HELP_ARTICLES,
        "slug=".concat(slug),
        "locale=".concat(locale)
    ];
};
const useHelpArticle = (slug, params)=>(0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)(getHelpArticleKey(slug, params), async ()=>getHelpArticle(slug), {
        keepPreviousData: true
    });
const prefetchHelpArticle = (queryClient, slug, params)=>queryClient.prefetchQuery(getHelpArticleKey(slug, params), async ()=>getHelpArticle(slug));
const useHelpArticleFeedback = ()=>(0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useMutation */ .D)((payload)=>_httpClient__WEBPACK_IMPORTED_MODULE_0__/* .httpClient.post */ .M.post("/help-center/feedback", payload));


/***/ }),

/***/ 53276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// UNUSED EXPORTS: Breadcrumbs

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js + 2 modules
var Breadcrumbs = __webpack_require__(8041);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./src/imports/NextLink/index.js + 1 modules
var NextLink = __webpack_require__(94369);
;// CONCATENATED MODULE: ./src/components/Breadcrumbs/Breadcrumbs.js




function ItemTrace(param) {
    let { icon ="/" , items  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
        separator: icon,
        "aria-label": "breadcrumb",
        children: items.map((param, index)=>{
            let { text , url  } = param;
            return url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                color: "inherit",
                href: url,
                style: {
                    fontSize: "16px",
                    textTransform: "capitalize"
                },
                children: text
            }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                color: "#000",
                variant: "caption",
                textTransform: "capitalize",
                children: text
            }, index);
        })
    });
}

;// CONCATENATED MODULE: ./src/components/Breadcrumbs/index.js


/* harmony default export */ var components_Breadcrumbs = (ItemTrace);


/***/ }),

/***/ 36401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_useQueryState; }
});

// UNUSED EXPORTS: useQueryState

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/useQueryState/queryTypes.js
const queryTypes = {
    string: {
        parse: (query, defaultValue)=>query !== undefined ? query : defaultValue,
        serialize: (value)=>value
    },
    integer: {
        parse: (query, defaultValue)=>query !== undefined ? parseInt(query) : defaultValue,
        serialize: (value)=>value
    },
    array: {
        parse: (query, defaultValue)=>query !== undefined ? JSON.parse(query) : defaultValue,
        serialize: (values)=>JSON.stringify(values !== null && values !== void 0 ? values : [])
    }
};
/* harmony default export */ var useQueryState_queryTypes = (queryTypes);

;// CONCATENATED MODULE: ./src/components/useQueryState/useQueryState.js



function useQueryState(key, param) {
    let { defaultValue ="" , type ="string"  } = param;
    const router = (0,next_router.useRouter)();
    const queryTypeHandler = useQueryState_queryTypes[type];
    const [filter, setFilter] = react.useState(defaultValue);
    const setQueryFilter = (value)=>{
        if (router.query[key] !== queryTypeHandler.serialize(value)) {
            router.query[key] = queryTypeHandler.serialize(value);
            router.push(router, null, {
                shallow: true
            });
        }
    };
    react.useEffect(()=>{
        setFilter(queryTypeHandler.parse(router.query[key], defaultValue));
    }, [
        queryTypeHandler.serialize(router.query[key])
    ]);
    return [
        filter,
        setQueryFilter
    ];
}
/* harmony default export */ var useQueryState_useQueryState = (useQueryState);

;// CONCATENATED MODULE: ./src/components/useQueryState/index.js


/* harmony default export */ var components_useQueryState = (useQueryState_useQueryState);


/***/ }),

/***/ 96571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ imports_SearchTextField; }
});

// UNUSED EXPORTS: SearchTextField

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/FlatTextField/index.js + 1 modules
var FlatTextField = __webpack_require__(35133);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(91057);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(66489);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Search.js
var Search = __webpack_require__(96506);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Close.js
var Close = __webpack_require__(95537);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/imports/SearchTextField/SearchTextField.js






function SearchTextField(param) {
    let { searchState =[] , size ="medium" , InputProps ={} , isLoading =false , ...props } = param;
    const [search, setSearch] = searchState;
    const handleSearchChange = react.useCallback((0,lodash.debounce)((value)=>setSearch(value), 500), []);
    const textRef = react.useRef(search);
    react.useEffect(()=>{
        textRef.current.value = search;
    }, [
        search
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatTextField/* default */.Z, {
        ref: textRef,
        onChange: (e)=>handleSearchChange(e.target.value),
        backgroundColor: "white",
        size: size,
        InputProps: {
            startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {})
            }),
            endAdornment: !!search && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "end",
                onClick: ()=>setSearch(""),
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                    size: 14
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    size: size,
                    edge: "end",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                        fontSize: "inherit"
                    })
                })
            }),
            ...InputProps
        },
        ...props
    });
}
/* harmony default export */ var SearchTextField_SearchTextField = (SearchTextField);

;// CONCATENATED MODULE: ./src/imports/SearchTextField/index.js


/* harmony default export */ var imports_SearchTextField = (SearchTextField_SearchTextField);


/***/ }),

/***/ 64243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ HelpCenterArticleSection; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/imports/SetupSection/index.js + 3 modules
var SetupSection = __webpack_require__(39156);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(48263);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(66489);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(22283);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/api/helpCenter.js
var helpCenter = __webpack_require__(42969);
// EXTERNAL MODULE: ./src/imports/NextLink/index.js + 1 modules
var NextLink = __webpack_require__(94369);
// EXTERNAL MODULE: ./src/components/Breadcrumbs/index.js + 1 modules
var Breadcrumbs = __webpack_require__(53276);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(55678);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ContentCopy.js
var ContentCopy = __webpack_require__(96406);
// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(16573);
// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookIcon.js
var FacebookIcon = __webpack_require__(1020);
// EXTERNAL MODULE: ./node_modules/react-share/es/TwitterShareButton.js
var TwitterShareButton = __webpack_require__(46616);
// EXTERNAL MODULE: ./node_modules/react-share/es/TwitterIcon.js
var TwitterIcon = __webpack_require__(87385);
// EXTERNAL MODULE: ./node_modules/react-share/es/LinkedinShareButton.js
var LinkedinShareButton = __webpack_require__(53597);
// EXTERNAL MODULE: ./node_modules/react-share/es/LinkedinIcon.js
var LinkedinIcon = __webpack_require__(37332);
// EXTERNAL MODULE: ./src/utils/quillStyleObject.js
var quillStyleObject = __webpack_require__(94309);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js
var Paper = __webpack_require__(21987);
// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js
var Collapse = __webpack_require__(12509);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Check.js
var Check = __webpack_require__(62026);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Close.js
var Close = __webpack_require__(95537);
// EXTERNAL MODULE: ./src/components/FlatTextField/index.js + 1 modules
var FlatTextField = __webpack_require__(35133);
// EXTERNAL MODULE: ./src/components/FlatButton/index.js + 1 modules
var FlatButton = __webpack_require__(54075);
// EXTERNAL MODULE: ./src/components/ResponsiveButton/index.js + 1 modules
var ResponsiveButton = __webpack_require__(97037);
;// CONCATENATED MODULE: ./src/sections/helpCenter/components/ArticleUseful.js










function ArticleUseful(param) {
    let { id  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)([
        "common",
        "help-center"
    ]);
    const [open, setOpen] = react.useState(false);
    const [feedback, setFeedback] = react.useState("");
    const [submitting, setSubmitting] = react.useState(false);
    const [submitted, setSubmitted] = react.useState(false);
    const feedbackMutation = (0,helpCenter/* useHelpArticleFeedback */.Rj)();
    const handleSubmit = ()=>{
        if (open) {
            setSubmitting(true);
            feedbackMutation.mutateAsync({
                feedback,
                article_id: id,
                is_useful: open === "yes"
            }).then(()=>setSubmitted(true)).catch(()=>react_toastify_esm/* toast.error */.Am.error("Failed to save your feedback")).finally(()=>setSubmitting(false));
        }
    };
    react.useEffect(()=>{
        setOpen(false);
        setFeedback("");
        setSubmitting(false);
        setSubmitted(false);
    }, [
        id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
        sx: {
            borderRadius: 2,
            mt: 14
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            p: 5,
            children: [
                !submitted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body1",
                                textTransform: "capitalize",
                                textAlign: "center",
                                display: "block",
                                children: t("help-center:is_this_article_was_useful")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 2,
                                justifyContent: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveButton/* default */.Z, {
                                            color: "primary",
                                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                                sx: {
                                                    transform: "scaleX(1)!important"
                                                }
                                            }),
                                            onClick: ()=>setOpen("yes"),
                                            disableElevation: true,
                                            variant: open === "yes" ? "contained" : "text",
                                            children: t("common:yes")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveButton/* default */.Z, {
                                            color: "error",
                                            startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {}),
                                            onClick: ()=>setOpen("no"),
                                            disableElevation: true,
                                            variant: open === "no" ? "contained" : "text",
                                            children: t("common:no")
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                                in: open,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatTextField/* default */.Z, {
                                            backgroundColor: "#F3F5F7",
                                            fullWidth: true,
                                            placeholder: "".concat(t("help-center:Your_feedback"), " (").concat(t("common:optional"), ")"),
                                            multiline: true,
                                            rows: 3,
                                            value: feedback,
                                            onChange: (e)=>setFeedback(e.target.value)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            mt: 2,
                                            sx: {
                                                textAlign: "right"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatButton/* default */.Z, {
                                                variant: "contained",
                                                disableElevation: true,
                                                isLoading: submitting,
                                                onClick: handleSubmit,
                                                children: t("common:submit")
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                !!submitted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    textAlign: "center",
                    display: "block",
                    children: t("help-center:Thank_you_for_your_feedback")
                })
            ]
        })
    });
}
/* harmony default export */ var components_ArticleUseful = (ArticleUseful);

;// CONCATENATED MODULE: ./src/sections/helpCenter/components/Article.js













function Article() {
    var _article_category, _articlesQuery_data, _article_category1, _article_category2, _article_category3;
    const { t  } = (0,esm/* useTranslation */.$G)([
        "common",
        "help-center"
    ]);
    const { query: { slug  } , locale  } = (0,router.useRouter)();
    const articleQuery = (0,helpCenter/* useHelpArticle */.SG)(slug, {
        locale
    });
    const article = articleQuery.data;
    const articlesQuery = (0,helpCenter/* useHelpArticles */.QX)({
        locale,
        category: article === null || article === void 0 ? void 0 : (_article_category = article.category) === null || _article_category === void 0 ? void 0 : _article_category.id
    });
    var _articlesQuery_data_data;
    const articlesOnThisPage = (_articlesQuery_data_data = (_articlesQuery_data = articlesQuery.data) === null || _articlesQuery_data === void 0 ? void 0 : _articlesQuery_data.data) !== null && _articlesQuery_data_data !== void 0 ? _articlesQuery_data_data : [];
    const shareURL = "https://www.blueassembly.com/".concat(locale, "/help-center/").concat(slug);
    var _article_category_title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        py: 10,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "xl",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                columnSpacing: 6,
                rowSpacing: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        md: 8,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                                items: [
                                    {
                                        text: t("help-center:home"),
                                        url: "/"
                                    },
                                    {
                                        text: t("help-center:help_center"),
                                        url: "/help-center"
                                    },
                                    ...(article === null || article === void 0 ? void 0 : (_article_category1 = article.category) === null || _article_category1 === void 0 ? void 0 : _article_category1.title) ? [
                                        {
                                            text: (_article_category_title = article === null || article === void 0 ? void 0 : (_article_category2 = article.category) === null || _article_category2 === void 0 ? void 0 : _article_category2.title) !== null && _article_category_title !== void 0 ? _article_category_title : "-",
                                            url: "/help-center?category=".concat(article === null || article === void 0 ? void 0 : (_article_category3 = article.category) === null || _article_category3 === void 0 ? void 0 : _article_category3.id)
                                        }
                                    ] : []
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                pb: 2,
                                sx: {
                                    overflow: "hidden"
                                },
                                children: [
                                    !!articleQuery.isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        container: true,
                                        justifyContent: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
                                    }),
                                    !articleQuery.isLoading && !article && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        textTransform: "capitalize",
                                        textAlign: "center",
                                        display: "block",
                                        pt: 2,
                                        children: t("help-center:article_not_found")
                                    }),
                                    !articleQuery.isLoading && article && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        container: true,
                                        spacing: 3,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                    direction: "row",
                                                    spacing: 1,
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            display: "block",
                                                            variant: "h4",
                                                            fontWeight: 700,
                                                            children: article.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                                container: true,
                                                                spacing: 0.5,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                                        item: true,
                                                                        sx: {
                                                                            lineHeight: 0
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                            size: "small",
                                                                            sx: {
                                                                                backgroundColor: "#DDD",
                                                                                p: "3px"
                                                                            },
                                                                            "aria-label": "copy to clipboard",
                                                                            onClick: ()=>{
                                                                                navigator.clipboard.writeText(shareURL).then(()=>{
                                                                                    react_toastify_esm/* toast.success */.Am.success(t("common:Share_link_copied_to_clipboard"));
                                                                                }).catch(()=>{
                                                                                    react_toastify_esm/* toast.error */.Am.error(t("common:Failed_to_copy_share_link"));
                                                                                });
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCopy/* default */.Z, {
                                                                                sx: {
                                                                                    color: "#000",
                                                                                    p: "1px"
                                                                                },
                                                                                fontSize: "inherit"
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                                        item: true,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
                                                                            url: shareURL,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookIcon/* default */.Z, {
                                                                                size: 24,
                                                                                round: true
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                                        item: true,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterShareButton/* default */.Z, {
                                                                            url: shareURL,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterIcon/* default */.Z, {
                                                                                size: 24,
                                                                                round: true
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                                        item: true,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedinShareButton/* default */.Z, {
                                                                            url: shareURL,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedinIcon/* default */.Z, {
                                                                                size: 24,
                                                                                round: true
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    dangerouslySetInnerHTML: {
                                                        __html: article === null || article === void 0 ? void 0 : article.html
                                                    },
                                                    sx: quillStyleObject/* default */.Z
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ArticleUseful, {
                                                    id: article.id
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        md: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            container: true,
                            spacing: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    sx: {
                                        display: {
                                            xs: "none",
                                            md: "block"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                        sx: {
                                            minHeight: 350
                                        },
                                        orientation: "vertical"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body1",
                                            display: "block",
                                            fontWeight: 700,
                                            textTransform: "capitalize",
                                            sx: {
                                                py: 3.5
                                            },
                                            children: t("help-center:related_articles")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            pl: 2,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                container: true,
                                                spacing: 1.5,
                                                children: [
                                                    !!articlesQuery.isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        container: true,
                                                        justifyContent: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
                                                    }),
                                                    articlesOnThisPage.map((articleOnThisPage)=>{
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                            item: true,
                                                            xs: 12,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                variant: "body2",
                                                                display: "block",
                                                                fontWeight: 500,
                                                                color: articleOnThisPage.id === (article === null || article === void 0 ? void 0 : article.id) ? "secondary.main" : "primary.main",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NextLink/* default */.Z, {
                                                                    href: "/help-center/".concat(articleOnThisPage.slug),
                                                                    children: [
                                                                        "- ",
                                                                        articleOnThisPage.title
                                                                    ]
                                                                })
                                                            })
                                                        }, articleOnThisPage.id);
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var components_Article = (Article);

// EXTERNAL MODULE: ./src/sections/helpCenter/HelpCenterLayout.js + 1 modules
var HelpCenterLayout = __webpack_require__(12699);
;// CONCATENATED MODULE: ./src/sections/helpCenter/HelpCenterArticleSection.js





function HelpCenterArticleSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HelpCenterLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Article, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SetupSection/* default */.Z, {})
        ]
    });
}
/* harmony default export */ var helpCenter_HelpCenterArticleSection = ((/* unused pure expression or super */ null && (HelpCenterArticleSection)));


/***/ }),

/***/ 12699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ helpCenter_HelpCenterLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(48263);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(22283);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/useQueryState/index.js + 2 modules
var useQueryState = __webpack_require__(36401);
// EXTERNAL MODULE: ./src/imports/SearchTextField/index.js + 1 modules
var SearchTextField = __webpack_require__(96571);
// EXTERNAL MODULE: ./src/api/helpCenter.js
var helpCenter = __webpack_require__(42969);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./src/sections/helpCenter/components/ArticleCard.js
var ArticleCard = __webpack_require__(87966);
;// CONCATENATED MODULE: ./src/sections/helpCenter/components/ArticleSearchResult.js





function ArticleSearchResult(param) {
    let { data  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)([
        "common"
    ]);
    var _data_reduce;
    const articles = (_data_reduce = data === null || data === void 0 ? void 0 : data.reduce((allArticles, item)=>[
            ...allArticles,
            ...item.articles
        ], [])) !== null && _data_reduce !== void 0 ? _data_reduce : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        py: 13,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "xl",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                spacing: 15,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        spacing: 5,
                        alignItems: "stretch",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h4",
                                    display: "block",
                                    textTransform: "capitalize",
                                    textAlign: "center",
                                    children: t("common:search_result")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    spacing: 2,
                                    children: [
                                        !articles.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                display: "block",
                                                gutterBottom: true,
                                                variant: "caption",
                                                color: "neutral.dark",
                                                textAlign: "center",
                                                children: t("common:there_is_no_search_result")
                                            })
                                        }),
                                        articles === null || articles === void 0 ? void 0 : articles.map((article, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        item: true,
                                                        xs: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCard/* default */.Z, {
                                                            article: article,
                                                            showCategory: true
                                                        })
                                                    }),
                                                    articles.length !== index + 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        item: true,
                                                        xs: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                                                    })
                                                ]
                                            }, article.id))
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
}
/* harmony default export */ var components_ArticleSearchResult = (ArticleSearchResult);

;// CONCATENATED MODULE: ./src/sections/helpCenter/HelpCenterLayout.js









function HelpCenterLayout(param) {
    let { children  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)([
        "common",
        "help-center"
    ]);
    const { locale  } = (0,router.useRouter)();
    const [q, setQ] = (0,useQueryState/* default */.Z)("q", {
        defaultValue: "",
        type: "string"
    });
    const helpArticleQuery = (0,helpCenter/* useHelpArticles */.QX)({
        locale,
        q
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            position: "relative",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    backgroundColor: "primary.main",
                    color: "primary.contrastText"
                },
                py: 10,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    maxWidth: "md",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        spacing: 5,
                        textAlign: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    variant: "h3",
                                    display: "block",
                                    textTransform: "capitalize",
                                    children: [
                                        t("common:Blue_Assembly"),
                                        " ",
                                        t("help-center:help_center")
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h6",
                                    display: "block",
                                    sx: {
                                        pb: 3
                                    },
                                    fontWeight: 300,
                                    children: t("help-center:Have_any_questions")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchTextField/* default */.Z, {
                                    fullWidth: true,
                                    placeholder: t("common:search"),
                                    size: "small",
                                    searchState: [
                                        q,
                                        setQ
                                    ],
                                    backgroundColor: "white",
                                    isLoading: helpArticleQuery.isRefetching
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                in: !q,
                sx: {
                    display: !q ? "" : "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                in: !!q,
                sx: {
                    display: q ? "" : "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ArticleSearchResult, {
                        data: helpArticleQuery.data
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var helpCenter_HelpCenterLayout = (HelpCenterLayout);


/***/ }),

/***/ 87966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21987);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23972);
/* harmony import */ var _imports_NextLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94369);




function ArticleCard(param) {
    let { article , showCategory =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_imports_NextLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        href: "/help-center/".concat(article.slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            sx: {
                height: "100%",
                p: 4,
                boxShadow: 0,
                backgroundColor: "transparent",
                cursor: "pointer",
                transition: (theme)=>theme.transitions.create([
                        "background-color",
                        "box-shadow"
                    ], {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.leavingScreen
                    }),
                ":hover": {
                    backgroundColor: "paper.main",
                    boxShadow: 1
                }
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    display: "block",
                    gutterBottom: true,
                    variant: "body2",
                    fontWeight: 700,
                    children: [
                        !!showCategory && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            display: "block",
                            gutterBottom: true,
                            variant: "caption",
                            component: "span",
                            fontWeight: 400,
                            fontSize: 14,
                            color: "primary.main",
                            children: article.category.title
                        }),
                        article.title
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    display: "block",
                    gutterBottom: true,
                    variant: "caption",
                    fontSize: 14,
                    fontWeight: 400,
                    color: "neutral.dark",
                    children: article.description
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ArticleCard);


/***/ }),

/***/ 94309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export quillStyleObject */
const quillStyleObject = {
    img: {
        maxWidth: "100%"
    },
    ".ql-container": {
        boxSizing: "border-box",
        fontFamily: "Helvetica, Arial, sans-serif",
        fontSize: "13px",
        height: "100%",
        margin: "0px",
        position: "relative"
    },
    ".ql-container.ql-disabled .ql-tooltip": {
        visibility: "hidden"
    },
    ".ql-container.ql-disabled .ql-editor ul[data-checked] > li::before": {
        pointerEvents: "none"
    },
    ".ql-clipboard": {
        left: "-100000px",
        height: "1px",
        overflowY: "hidden",
        position: "absolute",
        top: "50%"
    },
    ".ql-clipboard p": {
        margin: "0",
        padding: "0"
    },
    ".ql-editor": {
        boxSizing: "border-box",
        lineHeight: 1.42,
        height: "100%",
        outline: "none",
        overflowY: "auto",
        padding: "12px 15px",
        tabSize: 4,
        MozTabSize: "4",
        textAlign: "left",
        whiteSpace: "normal",
        wordWrap: "break-word"
    },
    ".ql-editor > *": {
        cursor: "text"
    },
    ".ql-editor p,\n.ql-editor ol,\n.ql-editor ul,\n.ql-editor pre,\n.ql-editor blockquote,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6": {
        margin: "0",
        padding: "0",
        counterReset: "list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9"
    },
    ".ql-editor ol,\n.ql-editor ul": {
        paddingLeft: "1.5em"
    },
    ".ql-editor ol > li,\n.ql-editor ul > li": {
        listStyleType: "none"
    },
    ".ql-editor ul > li::before": {
        content: '"\\2022"'
    },
    ".ql-editor ul[data-checked=true],\n.ql-editor ul[data-checked=false]": {
        pointerEvents: "none"
    },
    ".ql-editor ul[data-checked=true] > li *,\n.ql-editor ul[data-checked=false] > li *": {
        pointerEvents: "all"
    },
    ".ql-editor ul[data-checked=true] > li::before,\n.ql-editor ul[data-checked=false] > li::before": {
        color: "#777",
        cursor: "pointer",
        pointerEvents: "all"
    },
    ".ql-editor ul[data-checked=true] > li::before": {
        content: '"\\2611"'
    },
    ".ql-editor ul[data-checked=false] > li::before": {
        content: '"\\2610"'
    },
    ".ql-editor li::before": {
        display: "inline-block",
        whiteSpace: "nowrap",
        width: "1.2em"
    },
    ".ql-editor li:not(.ql-direction-rtl)::before": {
        marginLeft: "-1.5em",
        marginRight: "0.3em",
        textAlign: "right"
    },
    ".ql-editor li.ql-direction-rtl::before": {
        marginLeft: "0.3em",
        marginRight: "-1.5em"
    },
    ".ql-editor ol li:not(.ql-direction-rtl),\n.ql-editor ul li:not(.ql-direction-rtl)": {
        paddingLeft: "1.5em"
    },
    ".ql-editor ol li.ql-direction-rtl,\n.ql-editor ul li.ql-direction-rtl": {
        paddingRight: "1.5em"
    },
    ".ql-editor ol li": {
        counterReset: "list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9",
        counterIncrement: "list-0"
    },
    ".ql-editor ol li:before": {
        content: "counter(list-0, decimal) '. '"
    },
    ".ql-editor ol li.ql-indent-1": {
        counterIncrement: "list-1",
        counterReset: "list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9"
    },
    ".ql-editor ol li.ql-indent-1:before": {
        content: "counter(list-1, lower-alpha) '. '"
    },
    ".ql-editor ol li.ql-indent-2": {
        counterIncrement: "list-2",
        counterReset: "list-3 list-4 list-5 list-6 list-7 list-8 list-9"
    },
    ".ql-editor ol li.ql-indent-2:before": {
        content: "counter(list-2, lower-roman) '. '"
    },
    ".ql-editor ol li.ql-indent-3": {
        counterIncrement: "list-3",
        counterReset: "list-4 list-5 list-6 list-7 list-8 list-9"
    },
    ".ql-editor ol li.ql-indent-3:before": {
        content: "counter(list-3, decimal) '. '"
    },
    ".ql-editor ol li.ql-indent-4": {
        counterIncrement: "list-4",
        counterReset: "list-5 list-6 list-7 list-8 list-9"
    },
    ".ql-editor ol li.ql-indent-4:before": {
        content: "counter(list-4, lower-alpha) '. '"
    },
    ".ql-editor ol li.ql-indent-5": {
        counterIncrement: "list-5",
        counterReset: "list-6 list-7 list-8 list-9"
    },
    ".ql-editor ol li.ql-indent-5:before": {
        content: "counter(list-5, lower-roman) '. '"
    },
    ".ql-editor ol li.ql-indent-6": {
        counterIncrement: "list-6",
        counterReset: "list-7 list-8 list-9"
    },
    ".ql-editor ol li.ql-indent-6:before": {
        content: "counter(list-6, decimal) '. '"
    },
    ".ql-editor ol li.ql-indent-7": {
        counterIncrement: "list-7",
        counterReset: "list-8 list-9"
    },
    ".ql-editor ol li.ql-indent-7:before": {
        content: "counter(list-7, lower-alpha) '. '"
    },
    ".ql-editor ol li.ql-indent-8": {
        counterIncrement: "list-8",
        counterReset: "list-9"
    },
    ".ql-editor ol li.ql-indent-8:before": {
        content: "counter(list-8, lower-roman) '. '"
    },
    ".ql-editor ol li.ql-indent-9": {
        counterIncrement: "list-9"
    },
    ".ql-editor ol li.ql-indent-9:before": {
        content: "counter(list-9, decimal) '. '"
    },
    ".ql-editor .ql-indent-1:not(.ql-direction-rtl)": {
        paddingLeft: "3em"
    },
    ".ql-editor li.ql-indent-1:not(.ql-direction-rtl)": {
        paddingLeft: "4.5em"
    },
    ".ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right": {
        paddingRight: "3em"
    },
    ".ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right": {
        paddingRight: "4.5em"
    },
    ".ql-editor .ql-indent-2:not(.ql-direction-rtl)": {
        paddingLeft: "6em"
    },
    ".ql-editor li.ql-indent-2:not(.ql-direction-rtl)": {
        paddingLeft: "7.5em"
    },
    ".ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right": {
        paddingRight: "6em"
    },
    ".ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right": {
        paddingRight: "7.5em"
    },
    ".ql-editor .ql-indent-3:not(.ql-direction-rtl)": {
        paddingLeft: "9em"
    },
    ".ql-editor li.ql-indent-3:not(.ql-direction-rtl)": {
        paddingLeft: "10.5em"
    },
    ".ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right": {
        paddingRight: "9em"
    },
    ".ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right": {
        paddingRight: "10.5em"
    },
    ".ql-editor .ql-indent-4:not(.ql-direction-rtl)": {
        paddingLeft: "12em"
    },
    ".ql-editor li.ql-indent-4:not(.ql-direction-rtl)": {
        paddingLeft: "13.5em"
    },
    ".ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right": {
        paddingRight: "12em"
    },
    ".ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right": {
        paddingRight: "13.5em"
    },
    ".ql-editor .ql-indent-5:not(.ql-direction-rtl)": {
        paddingLeft: "15em"
    },
    ".ql-editor li.ql-indent-5:not(.ql-direction-rtl)": {
        paddingLeft: "16.5em"
    },
    ".ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right": {
        paddingRight: "15em"
    },
    ".ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right": {
        paddingRight: "16.5em"
    },
    ".ql-editor .ql-indent-6:not(.ql-direction-rtl)": {
        paddingLeft: "18em"
    },
    ".ql-editor li.ql-indent-6:not(.ql-direction-rtl)": {
        paddingLeft: "19.5em"
    },
    ".ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right": {
        paddingRight: "18em"
    },
    ".ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right": {
        paddingRight: "19.5em"
    },
    ".ql-editor .ql-indent-7:not(.ql-direction-rtl)": {
        paddingLeft: "21em"
    },
    ".ql-editor li.ql-indent-7:not(.ql-direction-rtl)": {
        paddingLeft: "22.5em"
    },
    ".ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right": {
        paddingRight: "21em"
    },
    ".ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right": {
        paddingRight: "22.5em"
    },
    ".ql-editor .ql-indent-8:not(.ql-direction-rtl)": {
        paddingLeft: "24em"
    },
    ".ql-editor li.ql-indent-8:not(.ql-direction-rtl)": {
        paddingLeft: "25.5em"
    },
    ".ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right": {
        paddingRight: "24em"
    },
    ".ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right": {
        paddingRight: "25.5em"
    },
    ".ql-editor .ql-indent-9:not(.ql-direction-rtl)": {
        paddingLeft: "27em"
    },
    ".ql-editor li.ql-indent-9:not(.ql-direction-rtl)": {
        paddingLeft: "28.5em"
    },
    ".ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right": {
        paddingRight: "27em"
    },
    ".ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right": {
        paddingRight: "28.5em"
    },
    ".ql-editor .ql-video": {
        display: "block",
        maxWidth: "100%"
    },
    ".ql-snow .ql-editor img": {
        maxWidth: "100%"
    },
    ".ql-editor .ql-video.ql-align-center": {
        margin: "0 auto"
    },
    ".ql-editor .ql-video.ql-align-right": {
        margin: "0 0 0 auto"
    },
    ".ql-editor .ql-bg-black": {
        backgroundColor: "#000"
    },
    ".ql-editor .ql-bg-red": {
        backgroundColor: "#e60000"
    },
    ".ql-editor .ql-bg-orange": {
        backgroundColor: "#f90"
    },
    ".ql-editor .ql-bg-yellow": {
        backgroundColor: "#ff0"
    },
    ".ql-editor .ql-bg-green": {
        backgroundColor: "#008a00"
    },
    ".ql-editor .ql-bg-blue": {
        backgroundColor: "#06c"
    },
    ".ql-editor .ql-bg-purple": {
        backgroundColor: "#93f"
    },
    ".ql-editor .ql-color-white": {
        color: "#fff"
    },
    ".ql-editor .ql-color-red": {
        color: "#e60000"
    },
    ".ql-editor .ql-color-orange": {
        color: "#f90"
    },
    ".ql-editor .ql-color-yellow": {
        color: "#ff0"
    },
    ".ql-editor .ql-color-green": {
        color: "#008a00"
    },
    ".ql-editor .ql-color-blue": {
        color: "#06c"
    },
    ".ql-editor .ql-color-purple": {
        color: "#93f"
    },
    ".ql-editor .ql-font-serif": {
        fontFamily: "Georgia, Times New Roman, serif"
    },
    ".ql-editor .ql-font-monospace": {
        fontFamily: "Monaco, Courier New, monospace"
    },
    ".ql-editor .ql-size-small": {
        fontSize: "0.75em"
    },
    ".ql-editor .ql-size-large": {
        fontSize: "1.5em"
    },
    ".ql-editor .ql-size-huge": {
        fontSize: "2.5em"
    },
    ".ql-editor .ql-direction-rtl": {
        direction: "rtl",
        textAlign: "inherit"
    },
    ".ql-editor .ql-align-center": {
        textAlign: "center"
    },
    ".ql-editor .ql-align-justify": {
        textAlign: "justify"
    },
    ".ql-editor .ql-align-right": {
        textAlign: "right"
    },
    ".ql-editor.ql-blank::before": {
        color: "rgba(0,0,0,0.6)",
        content: "attr(data-placeholder)",
        fontStyle: "italic",
        left: "15px",
        pointerEvents: "none",
        position: "absolute",
        right: "15px"
    },
    p: {
        margin: "0px"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (quillStyleObject);


/***/ })

}]);